"use strict";var e=require("./components/Tabs.js"),t=require("./components/Tab.js"),r=require("@vds-core/tabs");exports.Tabs=e.default,exports.Tab=t.default,Object.defineProperty(exports,"TabButton",{enumerable:!0,get:function(){return r.TabButton}});



//////////////////
// WEBPACK FOOTER
// ./~/@vds/tabs/cjs/index.js
// module id = 1572
// module chunks = 0